import React, { useState, useEffect } from 'react';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import { getFieldFormResultDetails } from 'utils/FieldTestsUtils';
import DetailsDisplay from 'components/FieldTests/DetailsDisplay';
import ArtifactsDisplay from 'components/FieldTests/ArtifactsDisplay';

const tabs = [
  new Tab({ label: "Field Test Details", value: "Details" }),
  new Tab({ label: "Associated Artifacts", value: "Artifacts" })
]

const FieldTestDetails = ({ FieldTestId, Artifacts }) => {
  const [activeTab, setActiveTab] = useState('Details');
  const [details, setDetails] = useState(null);

  useEffect(() => {
    let mounted = true;
    const asyncEffect = async () => {
      const data = await getFieldFormResultDetails(FieldTestId);
      mounted && setDetails(data);
    };9*
    !details && asyncEffect();
    return () => mounted = false;
  }, [details, FieldTestId]);

  return (
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >
      {activeTab === "Details" ? <DetailsDisplay key={1} attributes={details} loaded={!!details}/> : <ArtifactsDisplay FieldTestId={FieldTestId} />}
    </TabbedPage>
  )
}

export default FieldTestDetails;